import { analyticsEvent } from './analytics-controller.js';

function getSearchContainer(input) {
  return (
    input.closest(".search-bar__input-wrapper") ||
    input.closest(".search-input-wrapper")
  );
}

export default function initSearchSuggestions() {
  var inputs = document.querySelectorAll(
    "#js-search-field, .search-toggle-dashboard"
  );

  if (!inputs.length) return;

  inputs.forEach(function (input) {
    var container = getSearchContainer(input);
    if (!container) return;

    var suggestionsList = container.querySelector(".search-suggestions");
    if (!suggestionsList) return;

    var clearBtn = container.querySelector(".search-bar__clear");
    var searchBtn =
      container.querySelector(".search-bar__submit") ||
      container.querySelector(".search-icon-button");

    var debounceTimer = null;

    /* ---------------- fetch ---------------- */

    function fetchSuggestions(query) {
      var url = "/api/SuggestionApi/GetSuggestions?keyword=" + encodeURIComponent(query);
      // var url = "/api-json/getSuggestions.json"; // For testing with local json file
      fetch(url)
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          if (Array.isArray(data) && data.length) {
            renderSuggestions(data);
          } else {
            closeSuggestions();
          }
        });
    }

    /* ---------------- render ---------------- */
    function renderSuggestions(list) {
      var html = list
        .map(function (s) {
          return `
            <li class="search-suggestions-item" data-value="${s.title}">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                <use xlink:href="/dist/img/svg-sprite.svg#search"></use>
              </svg>
              <span>${s.title}</span>
            </li>
          `;
        })
        .join("");

      suggestionsList.innerHTML = html;
      suggestionsList.style.display = "block";
      suggestionsList.classList.add("is-open");

      input.classList.add("is-open");
      if(searchBtn) {
        searchBtn.classList.add("is-open");
      }
    }

    function closeSuggestions() {
      suggestionsList.innerHTML = "";
      suggestionsList.style.display = "none";
      suggestionsList.classList.remove("is-open");
      input.classList.remove("is-open"); 
      if(searchBtn) { searchBtn.classList.remove("is-open"); }
    }

    /* ---------------- input ---------------- */
    input.addEventListener("input", function () {
      var val = input.value.trim();
      clearTimeout(debounceTimer);

    var dataInfo = { 
      event_name: "search_suggester_triggered",
    };

      if (val.length >= 3) {
        debounceTimer = setTimeout(() => fetchSuggestions(val), 300);
        analyticsEvent( $.extend( analytics_data, dataInfo) );
      } else {
        closeSuggestions();
      }

      if (clearBtn) {
        clearBtn.classList.toggle("active", val.length > 0);
      }
    });

    /* ---------------- suggestion click ---------------- */

    suggestionsList.addEventListener("click", function (e) {
      var item = e.target.closest(".search-suggestions-item");
      if (!item) return;

      var dataInfo = {
        search_suggester_position: Array.from(suggestionsList.children).indexOf(item) + 1,
        search_suggester_click_name: item.getAttribute("data-value")
      };
      analyticsEvent( $.extend( analytics_data, dataInfo) );

      input.value = item.getAttribute("data-value"); 
      closeSuggestions();      

      if (input.classList.contains("search-toggle-dashboard")) {
        const form = input.closest("form");
        if (form) {
          form.submit();
        }
      } else {
        if (window.angular) {
          var el = angular.element(input);
          var scope = el.scope();
          if (scope && scope.query) {
            scope.query.keywords = input.value;
            if (typeof scope.query.update === "function") {
              scope.query.update();
            }
          }
        }
      }
    });

    /* ---------------- clear ---------------- */
    if (clearBtn) {
      clearBtn.addEventListener("click", function () {
        input.value = "";
        closeSuggestions();
        clearBtn.classList.remove("active");
      });
    }

    /* ---------------- outside click ---------------- */
    document.addEventListener("click", function (e) {
      if (!container.contains(e.target)) {
        closeSuggestions();
      }
    });

    /* ---------------- submit ---------------- */
    if (searchBtn) {
      searchBtn.addEventListener("click", function () {
        closeSuggestions();
      });
    }
  });
}

/* ---------- helper ---------- */

function getSearchContainer(input) {
  return (
    input.closest(".search-bar__input-wrapper") ||
    input.closest(".search-input-wrapper")
  );
}